module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logomaker"
  }, [(_vm.wait) ? _c('div', {
    attrs: {
      "id": "wait"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-md-4 bg-light sidebar"
  }, [_c('div', {
    staticClass: "sidebar-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fontCompany),
      expression: "fontCompany"
    }],
    staticClass: "form-control font",
    attrs: {
      "id": "fontCompany"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fontCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6 col-form-label",
    attrs: {
      "for": "companyColor"
    }
  }, [_vm._v("Couleur")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colorCompany),
      expression: "colorCompany"
    }],
    staticClass: "color form-control",
    attrs: {
      "type": "color",
      "id": "companyColor",
      "value": "#000000"
    },
    domProps: {
      "value": (_vm.colorCompany)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colorCompany = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-margin"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slogan),
      expression: "slogan"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Company's slogan"
    },
    domProps: {
      "value": (_vm.slogan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slogan = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fontSlogan),
      expression: "fontSlogan"
    }],
    staticClass: "form-control font",
    attrs: {
      "id": "fontSlogan"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fontSlogan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6 col-form-label",
    attrs: {
      "for": "sloganColor"
    }
  }, [_vm._v("Couleur")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colorSlogan),
      expression: "colorSlogan"
    }],
    staticClass: "color form-control",
    attrs: {
      "type": "color",
      "id": "sloganColor",
      "value": "#000000"
    },
    domProps: {
      "value": (_vm.colorSlogan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colorSlogan = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-frame"
  }, [_c('div', {
    staticClass: "picto"
  }, [_c('ul', _vm._l((_vm.icons), function(icon) {
    return _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.logo),
        expression: "logo"
      }],
      attrs: {
        "type": "radio",
        "name": "logo"
      },
      domProps: {
        "value": icon,
        "checked": _vm._q(_vm.logo, icon)
      },
      on: {
        "__c": function($event) {
          _vm.logo = icon
        }
      }
    }), _c('i', {
      class: icon
    }), _vm._v(" " + _vm._s(icon))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-6 col-form-label",
    attrs: {
      "for": "colorLogo"
    }
  }, [_vm._v("Couleur")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colorLogo),
      expression: "colorLogo"
    }],
    staticClass: "color form-control",
    attrs: {
      "type": "color",
      "id": "logoColor",
      "value": "#000000"
    },
    domProps: {
      "value": (_vm.colorLogo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colorLogo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alignLogo),
      expression: "alignLogo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alignLogo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v("Pictogramme à gauche")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v("Pictogramme à droite")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "center"
    }
  }, [_vm._v("Pictogramme au dessus")])]), _vm._v(" "), _c('div', {
    staticClass: "small-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.save('logo-oven')
      }
    }
  }, [_c('i', {
    staticClass: "icofont icofont-download-alt"
  }), _vm._v(" Télécharger")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-9 col-md-8 workspace gradient-pattern"
  }, [_c('div', {
    class: _vm.alignLogo,
    attrs: {
      "id": "logo-oven"
    }
  }, [_c('i', {
    staticClass: "icofont-5x fa-5x",
    class: _vm.logo,
    style: ({
      color: _vm.colorLogo
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "company",
    style: ({
      fontFamily: _vm.fontCompany,
      color: _vm.colorCompany
    })
  }, [_vm._v(_vm._s(_vm.company))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "slogan",
    style: ({
      fontFamily: _vm.fontSlogan,
      color: _vm.colorSlogan
    })
  }, [_vm._v(_vm._s(_vm.slogan))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/onlinecreation.png"),
      "alt": "onlinecreation.me"
    }
  }), _vm._v(" "), _c('h1', [_c('strong', [_vm._v("dessine-moi")]), _vm._v(" un "), _c('strong', [_vm._v("logo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbd307a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 23
// module chunks = 0